export default {
      id: "i-bpif-about-2-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/sprite.svg#i-bpif-about-2",
      toString: function () {
        return this.url;
      }
    }